import { keyframes } from "styled-components";


/**
 * @deprecated
 */
export const keyFrameBackground = keyframes`
	0% {
		background-position: left top;
	}
	10% {
		background-position: left bottom;
	}
	
	20% {
		background-position: right bottom;
	}
	
	30% {
		background-position: right top;
	}
	
	40% {
		background-position: left top;
		transform: scale(1);
	}

	50% {
		transform: scale(1.2);
		transform-origin: left top;
	}
	
	60% {
		transform: scale(1.2);
		transform-origin: right top;
	}
	
	70% {
		transform: scale(1.2);
		transform-origin: right bottom;
	}
	
	80% {
	    transform: scale(1.2);
		transform-origin: left bottom;
	}
	
	90% {
	    transform: scale(1.2);
		transform-origin: center;
	}
`;
